<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.2856 17.6538L8.63184 12L14.2856 6.34625L15.3393 7.4L10.7393 12L15.3393 16.6L14.2856 17.6538Z" fill="currentColor"/>
</svg>
